module.exports = __webpack_public_path__ + "static/media/winners.032a6d88.svg";